import * as yup from "yup";
import { UFS_QUE_CONSULTAMOS } from "../Constants";

const regexPlacas = /^[A-Za-z]{3}-?\d[0-9A-Za-z]\d{2}$/;

export const filtrosListarSolicitacoesLicenciamento = yup.object({
  placa: yup.string().optional().nullable().matches(regexPlacas, {
    excludeEmptyString: true,
    message: "Placa inválida",
  }),

  periodoSolicitacao: yup.array().optional().nullable(),

  statusEmissao: yup
    .string()
    .oneOf(["finalizado", "processando"])
    .optional()
    .nullable(),

  uf: yup
    .string()
    .min(2)
    .max(2)
    .oneOf(UFS_QUE_CONSULTAMOS)
    .optional()
    .nullable(),

  renavam: yup.string().optional().nullable().max(11),

  idEmpresa: yup.number().optional().nullable(),

  cobranca: yup.string().optional().nullable(),
});

export const filtroProcessoCriarLoteLicenciamentosSchema = yup.object().shape({
  servicoProcesso: yup.number().optional().nullable(),
  processos: yup
    .array()
    .of(yup.number().typeError("ID deve ser numérico"))
    .optional()
    .nullable(),
  placasChassisRenavams: yup
    .array()
    .of(yup.string().typeError("Valor inválido"))
    .optional()
    .nullable(),
  idEmpresa: yup.number().optional().nullable(),
});
